import { useEffect, useState } from "react";
import axiosInstance from "../connections/axiosInstance";
import { getSessionStorage } from "../services/getSessionStorage";

export default function PriceList() {
    const [items, setItems] = useState(getSessionStorage("price"))
    const [item, setItem] = useState({
        name: "",
        price_from_indonesia: 0,
        price_from_japan: 0,
        category: "kg",
    });

    useEffect(() => {
        const getItems = async () => {
            const { data } = await axiosInstance.get("/price_list")
            sessionStorage.setItem("price", JSON.stringify(data.result))
            setItems(data.result)
        }

        getItems()
    }, [])

    function changeHandler(event) {
        // change handler
        const { name, value } = event.target;
        setItem((prev) => ({ ...prev, [name]: value }));
    }

    async function deleteHandler(itemID){
        const response = await axiosInstance.delete(`/price_list/${itemID}`)

        if (response.status === 200) {
            setItems((prev) => {
                return prev.filter((item) => item._id !== itemID)
            })
        }
    }

    async function submitHandler(){
        //submit handler
        const response = await axiosInstance.post("/price_list", item)

        if (response.status === 201) {
            setItems((prev) => ([ ...prev, response.data.result]))
        }
    }

    return (
        <main className="w-full h-screen max-[768px]:p-2">
            <section className="p-3.5 bg-white rounded-xl shadow md:w-max h-max mb-5">
                <h1 className="font-bold mb-4">CREATE NEW PRICE ITEM</h1>
                <div className="">
                    <span>Item name</span>
                    <input
                        type="text"
                        className="p-1.5 px-2 rounded-md outline-none border border-[var(--gray-light)] w-full my-1"
                        name="name"
                        value={item.name}
                        onChange={changeHandler}
                    />
                </div>
                <div className="">
                    <span>Item price from Indoesia</span>
                    <input
                        type="text"
                        className="p-1.5 px-2 rounded-md outline-none border border-[var(--gray-light)] w-full my-1"
                        name="price_from_indonesia"
                        value={item.price_from_indonesia}
                        onChange={changeHandler}
                    />
                </div>
                <div className="">
                    <span>Item price from Japan</span>
                    <input
                        type="text"
                        className="p-1.5 px-2 rounded-md outline-none border border-[var(--gray-light)] w-full my-1"
                        name="price_from_japan"
                        value={item.price_from_japan}
                        onChange={changeHandler}
                    />
                </div>
                <div className="">
                    <span>Item category</span>
                    <select
                        name="category"
                        onChange={changeHandler}
                        value={item.category}
                        className="p-2 rounded-md outline-none border border-[var(--gray-light)] w-full my-1 bg-white"
                    >
                        <option value="kg">kg</option>
                        <option value="pair">pair</option>
                        <option value="pcs">pcs</option>
                        <option value="slop">slop</option>
                        <option value="item">item</option>
                    </select>
                </div>
                <button className="my-3.5 w-full bg-[var(--blue)] text-white p-2 rounded-md" onClick={submitHandler}>SUBMIT</button>
            </section>
            <h1 className="font-bold mb-4">PRICE LIST</h1>
            <section className=" bg-white overflow-scroll rounded-xl shadow md:w-2/4 md:h-2/4">
                <table className="w-full text-left overflow-scroll">
                    <thead className="sticky top-0">
                        <tr>
                            <th>DESCRIPTION</th>
                            <th>FROM IDN</th>
                            <th>FROM JPN</th>
                            <th>ACTION</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            items.map((item, index) => 
                                <tr className="" key={index}>
                                    <td>{item.name}</td>
                                    <td>{Intl.NumberFormat().format(item.price_from_indonesia)}</td>
                                    <td>{Intl.NumberFormat().format(item.price_from_japan)}</td>
                                    <td>
                                        <button className="underline text-[var(--red)]" onClick={() => deleteHandler(item._id)}>
                                            delete
                                        </button>
                                    </td>
                                </tr>
                            )
                        }
                    </tbody>
                </table>
            </section>
        </main>
    );
}
